import { render, staticRenderFns } from "./PositionPicker.vue?vue&type=template&id=64f9f5e4"
import script from "./PositionPicker.vue?vue&type=script&lang=js"
export * from "./PositionPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports